import { graphql } from '@api/gql';

export const inventoryIntegrationsTriggerValuesDocument = graphql(/* GraphQL */ `
  query InventoryIntegrationsTriggerValues($ids: [String!]) {
    integrations(filter: { ids: $ids }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`);

export const inventoryResourceTypesTriggerValuesDocument = graphql(/* GraphQL */ `
  query InventoryResourceTypesTriggerValues($ids: [String!]) {
    integrationsResourceTypes(filter: { typeIds: $ids }) {
      type
      typeDisplayName
    }
  }
`);
